// extracted by mini-css-extract-plugin
export default {"navigationItems":"NavigationItems_navigationItems__kWwai","column":"NavigationItems_column__2H21J","row":"NavigationItems_row__hJvDH"};